import React from "react";
import { useSelector } from "react-redux";
import { Toaster } from "react-hot-toast";
import { Routes, Route, useLocation } from "react-router-dom";

import BottomNav from "./components/BottomNav";
import PrivateRoute from "./components/auth/PrivateRoute";

// Pages
import LoginPage from "./pages/LoginPage";
import HomePage from "./pages/HomePage";
import ProfilePage from "./pages/Profile/ProfilePage";
import SurveyPage from "./pages/survey/SurveyPage";
import SurveySectionsPage from "./pages/survey/SurveySectionsPage";
import SurveySummary from "./pages/survey/SurveySummary";

// 🔹 Kiosk Survey Sections
import KioskSectionA from "./pages/survey/kiosk/SectionA_GeneralInformation";
import KioskSectionB from "./pages/survey/kiosk/SectionBQualityQuantity";
import KioskSectionC from "./pages/survey/kiosk/SectionCWaterSupply";
import KioskSectionD from "./pages/survey/kiosk/SectionDKitchenDining";
import KioskSectionE from "./pages/survey/kiosk/SectionESafety";
import KioskSectionF from "./pages/survey/kiosk/SectionFSanitation";
import KioskSectionG from "./pages/survey/kiosk/SectionGWasteManagement";
import KioskSectionH from "./pages/survey/kiosk/SectionHPersonalHygiene";
import KioskSectionI from "./pages/survey/kiosk/SectionIFoodHygiene";
import KioskSectionJ from "./pages/survey/kiosk/SectionJIECMonitoring";
import KioskSectionK from "./pages/survey/kiosk/SectionKChallenges";

// 🔹 Kitchen Facility Survey Sections
import KitchenSectionA from "./pages/survey/kitchenfacility/SectionA_GeneralInformation";
import KitchenSectionB from "./pages/survey/kitchenfacility/SectionBQualityQuantity";
import KitchenSectionC from "./pages/survey/kitchenfacility/SectionCWaterSupply";
import KitchenSectionD from "./pages/survey/kitchenfacility/SectionDKitchenDining";
import KitchenSectionE from "./pages/survey/kitchenfacility/SectionESafety";
import KitchenSectionF from "./pages/survey/kitchenfacility/SectionFSanitation";
import KitchenSectionG from "./pages/survey/kitchenfacility/SectionGWasteManagement";
import KitchenSectionH from "./pages/survey/kitchenfacility/SectionHPersonalHygiene";
import KitchenSectionI from "./pages/survey/kitchenfacility/SectionIFoodHygiene";
import KitchenSectionJ from "./pages/survey/kitchenfacility/SectionJIECMonitoring";
import KitchenSectionK from "./pages/survey/kitchenfacility/SectionKChallenges";

// 🔹 Kitchen Cum Dining Survey Sections
import KitchenCumDiningSectionA from "./pages/survey/kitchencumDining/SectionA_GeneralInformation";
import KitchenCumDiningSectionB from "./pages/survey/kitchencumDining/SectionBQualityQuantity";
import KitchenCumDiningSectionC from "./pages/survey/kitchencumDining/SectionCWaterSupply";
import KitchenCumDiningSectionD from "./pages/survey/kitchencumDining/SectionDKitchenDining";
import KitchenCumDiningSectionE from "./pages/survey/kitchencumDining/SectionESafety";
import KitchenCumDiningSectionF from "./pages/survey/kitchencumDining/SectionFSanitation";
import KitchenCumDiningSectionG from "./pages/survey/kitchencumDining/SectionGWasteManagement";
import KitchenCumDiningSectionH from "./pages/survey/kitchencumDining/SectionHPersonalHygiene";
import KitchenCumDiningSectionI from "./pages/survey/kitchencumDining/SectionIFoodHygiene";
import KitchenCumDiningSectionJ from "./pages/survey/kitchencumDining/SectionJIECMonitoring";
import KitchenCumDiningSectionK from "./pages/survey/kitchencumDining/SectionKChallenges";

// Wrapper component to pass location state to section components
const SectionWrapper = ({ Component }) => {
  const location = useLocation();
  const state = location.state;
  
  // console.log("SectionWrapper - Rendering with state:", state);
  
  return <Component state={state} />;
};

// 🔹 Generic Section Router Component - FIXED VERSION
const SectionRouter = ({ type }) => {
  // Normalize type for consistency - handle both "kitchendining" and "kitchencumdining"
  let normalizedType = type?.toLowerCase();
  
  // Map "kitchendining" to "kitchencumdining"
  if (normalizedType === 'kitchendining') {
    normalizedType = 'kitchencumdining';
  }
  
  console.log("SectionRouter - Type received:", type, "Normalized:", normalizedType);
  
  switch (normalizedType) {
    case 'kiosk':
      return (
        <Routes>
          <Route path="section-a" element={<PrivateRoute><SectionWrapper Component={KioskSectionA} /></PrivateRoute>} />
          <Route path="section-b" element={<PrivateRoute><SectionWrapper Component={KioskSectionB} /></PrivateRoute>} />
          <Route path="section-c" element={<PrivateRoute><SectionWrapper Component={KioskSectionC} /></PrivateRoute>} />
          <Route path="section-d" element={<PrivateRoute><SectionWrapper Component={KioskSectionD} /></PrivateRoute>} />
          <Route path="section-e" element={<PrivateRoute><SectionWrapper Component={KioskSectionE} /></PrivateRoute>} />
          <Route path="section-f" element={<PrivateRoute><SectionWrapper Component={KioskSectionF} /></PrivateRoute>} />
          <Route path="section-g" element={<PrivateRoute><SectionWrapper Component={KioskSectionG} /></PrivateRoute>} />
          <Route path="section-h" element={<PrivateRoute><SectionWrapper Component={KioskSectionH} /></PrivateRoute>} />
          <Route path="section-i" element={<PrivateRoute><SectionWrapper Component={KioskSectionI} /></PrivateRoute>} />
          <Route path="section-j" element={<PrivateRoute><SectionWrapper Component={KioskSectionJ} /></PrivateRoute>} />
          <Route path="section-k" element={<PrivateRoute><SectionWrapper Component={KioskSectionK} /></PrivateRoute>} />
        </Routes>
      );
    case 'kitchen':
      return (
        <Routes>
          <Route path="section-a" element={<PrivateRoute><SectionWrapper Component={KitchenSectionA} /></PrivateRoute>} />
          <Route path="section-b" element={<PrivateRoute><SectionWrapper Component={KitchenSectionB} /></PrivateRoute>} />
          <Route path="section-c" element={<PrivateRoute><SectionWrapper Component={KitchenSectionC} /></PrivateRoute>} />
          <Route path="section-d" element={<PrivateRoute><SectionWrapper Component={KitchenSectionD} /></PrivateRoute>} />
          <Route path="section-e" element={<PrivateRoute><SectionWrapper Component={KitchenSectionE} /></PrivateRoute>} />
          <Route path="section-f" element={<PrivateRoute><SectionWrapper Component={KitchenSectionF} /></PrivateRoute>} />
          <Route path="section-g" element={<PrivateRoute><SectionWrapper Component={KitchenSectionG} /></PrivateRoute>} />
          <Route path="section-h" element={<PrivateRoute><SectionWrapper Component={KitchenSectionH} /></PrivateRoute>} />
          <Route path="section-i" element={<PrivateRoute><SectionWrapper Component={KitchenSectionI} /></PrivateRoute>} />
          <Route path="section-j" element={<PrivateRoute><SectionWrapper Component={KitchenSectionJ} /></PrivateRoute>} />
          <Route path="section-k" element={<PrivateRoute><SectionWrapper Component={KitchenSectionK} /></PrivateRoute>} />
        </Routes>
      );
    case 'kitchencumdining':
      return (
        <Routes>
          <Route path="section-a" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionA} /></PrivateRoute>} />
          <Route path="section-b" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionB} /></PrivateRoute>} />
          <Route path="section-c" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionC} /></PrivateRoute>} />
          <Route path="section-d" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionD} /></PrivateRoute>} />
          <Route path="section-e" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionE} /></PrivateRoute>} />
          <Route path="section-f" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionF} /></PrivateRoute>} />
          <Route path="section-g" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionG} /></PrivateRoute>} />
          <Route path="section-h" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionH} /></PrivateRoute>} />
          <Route path="section-i" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionI} /></PrivateRoute>} />
          <Route path="section-j" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionJ} /></PrivateRoute>} />
          <Route path="section-k" element={<PrivateRoute><SectionWrapper Component={KitchenCumDiningSectionK} /></PrivateRoute>} />
        </Routes>
      );
    default:
      return (
        <div className="p-8 text-center">
          <h2 className="text-xl text-red-600">Invalid survey type</h2>
          <p className="text-gray-600 mt-2">Type received: "{type}"</p>
          <p className="text-gray-600">Valid types: kiosk, kitchen, kitchencumdining, kitchendining</p>
        </div>
      );
  }
};

const AppWrapper = () => {
  const location = useLocation();
  const { user } = useSelector((state) => state.auth);

  // Extract survey type from URL - Handle both "kitchendining" and "kitchencumdining"
  const surveyTypeMatch = location.pathname.match(/\/survey\/(kiosk|kitchen|kitchendining|kitchencumdining)\//);
  let surveyType = surveyTypeMatch ? surveyTypeMatch[1] : null;
  
  // Normalize "kitchendining" to "kitchencumdining" for routing
  if (surveyType === 'kitchendining') {
    surveyType = 'kitchencumdining';
  }

  // Debug: Check if survey type is being extracted correctly
  React.useEffect(() => {
    if (surveyTypeMatch) {
      console.log("AppWrapper - Pathname:", location.pathname);
      console.log("AppWrapper - Extracted survey type:", surveyType);
    }
  }, [location.pathname, surveyTypeMatch, surveyType]);

  // Show BottomNav on ALL pages except login
  const showBottomNav = user && location.pathname !== "/" && location.pathname !== "/login";

  return (
    <div className="h-screen flex flex-col">
      <Toaster position="top-right" />

      <div className="flex-1 overflow-auto pb-16">
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LoginPage />} />
          <Route path="/login" element={<LoginPage />} />

          {/* Main Routes */}
          <Route path="/home" element={<PrivateRoute><HomePage /></PrivateRoute>} />
          <Route path="/profile" element={<PrivateRoute><ProfilePage /></PrivateRoute>} />
          <Route path="/survey" element={<PrivateRoute><SurveyPage /></PrivateRoute>} />

          {/* Survey Navigation */}
          <Route path="/survey/sections" element={<PrivateRoute><SurveySectionsPage /></PrivateRoute>} />
          <Route path="/survey/summary" element={<PrivateRoute><SurveySummary /></PrivateRoute>} />

          {/* Dynamic Survey Section Routes - Support both naming conventions */}
          <Route path="/survey/kiosk/*" element={<SectionRouter type="kiosk" />} />
          <Route path="/survey/kitchen/*" element={<SectionRouter type="kitchen" />} />
          <Route path="/survey/kitchendining/*" element={<SectionRouter type="kitchendining" />} />
          <Route path="/survey/kitchencumDining/*" element={<SectionRouter type="kitchencumdining" />} />
        </Routes>
      </div>

      {showBottomNav && <BottomNav />}
    </div>
  );
};

export default AppWrapper;